//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HorizontalScroll',
  data() {
    return {
      isDragging: false,
      startX: 0,
      scrollLeft: 0
    }
  },
  mounted() {
    // 组件挂载时，把鼠标移动和松开事件绑定到全局 window 上，解决移出容器外失效的问题
    window.addEventListener('mousemove', this.handleMouseMove)
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  beforeDestroy() {
    // 组件销毁前务必移除全局监听，防止内存泄漏
    window.removeEventListener('mousemove', this.handleMouseMove)
    window.removeEventListener('mouseup', this.handleMouseUp)
  },
  methods: {
    // --- PC 端鼠标事件 ---
    handleMouseDown(e) {
      this.isDragging = true
      const container = this.$refs.scrollRef
      if (container) {
        container.classList.add('dragging')
        this.startX = e.clientX
        this.scrollLeft = container.scrollLeft
      }
    },

    handleMouseMove(e) {
      if (!this.isDragging) return
      e.preventDefault()

      const container = this.$refs.scrollRef
      if (container) {
        const x = e.clientX
        const walk = x - this.startX
        container.scrollLeft = this.scrollLeft - walk
      }
    },

    handleMouseUp() {
      if (!this.isDragging) return
      this.isDragging = false
      const container = this.$refs.scrollRef
      if (container) {
        container.classList.remove('dragging')
      }
    },

    // --- 移动端 Touch 触摸事件 (移动端一般在当前元素即可，不会有移出外面的问题) ---
    handleTouchStart(e) {
      this.isDragging = true
      const container = this.$refs.scrollRef
      if (container) {
        container.classList.add('dragging')
        this.startX = e.touches[0].clientX
        this.scrollLeft = container.scrollLeft
      }
    },

    handleTouchMove(e) {
      if (!this.isDragging) return

      const container = this.$refs.scrollRef
      if (container) {
        const x = e.touches[0].clientX
        const walk = x - this.startX
        container.scrollLeft = this.scrollLeft - walk
      }
    },

    handleTouchEnd() {
      if (!this.isDragging) return
      this.isDragging = false
      const container = this.$refs.scrollRef
      if (container) {
        container.classList.remove('dragging')
      }
    }
  }
}
